import React, { PropsWithChildren } from 'react'
import { AddToCartHookState, ShoppingCartContext } from './ShoppingCartContext'

export const ShoppingCartProvider = ({ children }: PropsWithChildren) => {
  const [state, setState] = React.useState<AddToCartHookState>({})

  return (
    <ShoppingCartContext.Provider value={{ state, setState }}>
      {children}
    </ShoppingCartContext.Provider>
  )
}
